import { PaymentAddComponentProps, PaymentMethod, ProviderSelection } from '@fox/finance';

export const ProviderExtensionNames = {
	Stripe: 'Stripe',
	NabTransact: 'nab',
	BPoint: 'BPoint',
	AusBecs: 'aus-becs',
	FatZebra: 'FatZebra',
	PayWay: 'PayWay'
} as const;

export type AddPaymentWrapperProps = {
	component: React.FC<PaymentAddComponentProps>;
	provider: ProviderSelection;
	onSuccess: (id: number) => void;
	meta?: Record<string, unknown>;
	onCancel?: () => void;
	settings?: unknown;
};

export type PaymentProvider = {
	method: PaymentMethod;
	provider: string;
};
